import styled from 'styled-components';

export const SelectorDiv = styled.div<{
  isSelected: boolean;
  disabled?: boolean;
}>`
  width: 45px;
  height: 25px;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.palette.primary.main : theme.palette.divider};
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: ${(props) => (props.isSelected ? '20px' : '0')};
  transition: all 0.1s linear;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
`;

export const WhiteCircle = styled.div`
  height: 23px;
  width: 23px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.grey['500']};
  margin-left: 1px;
  margin-right: 1px;
`;

export const WhiteCircleSmall = styled(WhiteCircle)`
  height: 10px;
  width: 10px;
  margin-left: 2px;
  margin-right: 2px;
`;

export const SelectorDivSmall = styled(SelectorDiv)<{
  isSelected: boolean;
  disabled?: boolean;
}>`
  width: 26px;
  height: 14px;
  border-radius: 25px;
  padding-left: ${(props) => (props.isSelected ? '12px' : '0')};
  cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.div`
  padding: 0 5px;
  font-size: 10px;
`;
